import styled from '@emotion/styled'

import media from './../../../common/MediaQueries'
import { WithTheme } from './../../../setup/index'

const IframeContainerStyled = styled.div`
  width: 100%;
`

const IframeStyled = styled.div<WithTheme>`
  position: relative;
  background-color: ${({ theme }) => theme.colors.grayLight};
  background-color: black;
  width: 100%;
  padding: 2.5rem 0;

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 0;
    width: 100vw;
    height: 100%;
    background: ${({ theme }) => theme.colors.grayLight};
  }

  &:before {
    left: 0;
  }

  &:after {
    right: 100%;
  }

  @media ${media.phone} {
    padding: 2.5rem 0 5rem;
  }
  iframe {
    position: relative;
    width: 100%;
    z-index: 1;
  }
`

export { IframeContainerStyled, IframeStyled }
